// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ytuTynB\\+4sFRvgkfoJCtSw\\=\\={height:1.7rem;width:1.5rem}", "",{"version":3,"sources":["webpack://./resources/js/components/Icons/LocationIcon/styles.module.scss"],"names":[],"mappings":"AAAA,6BAEI,aAAA,CADA,YAEJ","sourcesContent":[".svg {\n    width: 1.5rem;\n    height: 1.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svg": "ytuTynB+4sFRvgkfoJCtSw=="
};
export default ___CSS_LOADER_EXPORT___;
